export default function getFontFamily(fontFamilyType, fontWeight, coreTheme) {
  const ffType = fontFamilyType === 'secondary' ? 'sec' : 'pri';
  return coreTheme[`ff_${ffType}_${fontWeight}`];
}
